import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-20 px-4 bg-cream-alt" data-id="element-146">
      <div className="max-w-3xl mx-auto" data-id="element-147">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-148">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-149">
            Si tu mente nunca se detiene, no estás solo
          </motion.h2>

          <motion.div variants={itemVariants} className="space-y-6 text-lg md:text-xl text-brown-light leading-relaxed mb-10" data-id="element-150">
            <p data-id="element-151">Muchas personas viven con la mente en constante ruido.</p>
            <p data-id="element-152">
              Pensando demasiado. Analizando todo. Preocupándose por situaciones
              que todavía no pasaron.
            </p>
            <p data-id="element-153">Tal vez te pasa algo como esto:</p>
          </motion.div>

          <motion.ul variants={itemVariants} className="space-y-4 mb-12 bg-cream p-8 rounded-2xl shadow-sm border border-brown/5" data-id="element-154">
            {['Te cuesta desconectar la mente', 'Analizas conversaciones del pasado una y otra vez', 'Te preocupas demasiado por el futuro', 'Sientes tensión mental constante', 'Tu mente no descansa ni cuando intentas relajarte'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-155">
                <span className="text-gold-end text-2xl leading-none mt-1" data-id="element-156">
                  •
                </span>
                <span className="text-lg text-brown font-medium" data-id="element-157">{item}</span>
              </li>)}
          </motion.ul>

          <motion.div variants={itemVariants} className="text-center space-y-4 text-lg md:text-xl font-medium text-brown" data-id="element-158">
            <p data-id="element-159">Y aunque intentes distraerte…</p>
            <p className="text-2xl font-playfair italic text-gold-end" data-id="element-160">
              Tu mente vuelve al mismo lugar.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}